import {
  CodeBlock,
  DescriptionList,
  DescriptionListTerm,
  DescriptionListGroup,
  DescriptionListDescription,
  ExpandableSection,
} from '@patternfly/react-core'
import { Tr, Td } from '@patternfly/react-table'
import * as React from 'react'
import styled from 'styled-components'

import type { IDomainEvent } from '@app/domain/domain-events/domain-events.interface'

interface Props {
  domainEvent: IDomainEvent
  expandedRows: Record<string, boolean>
  index: number
}

const Row = styled(Tr)`
  .label {
    width: fit-content;
  }
  .content {
    white-space: pre;
  }
  .additional-row {
    margin-top: 1em;
  }
`

export const BroadcastRow = function ({
  domainEvent,
  expandedRows,
  index,
}: Props) {
  const descriptionListGroupKey = React.useCallback(
    (id) => `description_group_${index}_${id}`,
    [index],
  )

  return (
    <Row
      key={index}
      isExpanded={expandedRows[domainEvent.id] === true}
      className="Row"
    >
      <Td />
      <Td colSpan={5}>
        <DescriptionList columnModifier={{ xl: '3Col' }}>
          <DescriptionListGroup key={descriptionListGroupKey(0)}>
            <DescriptionListTerm className="Row">
              broadcastType
            </DescriptionListTerm>
            <DescriptionListDescription className="content">
              {domainEvent.data['broadcastType']}
            </DescriptionListDescription>
          </DescriptionListGroup>
          <DescriptionListGroup key={descriptionListGroupKey(1)}>
            <DescriptionListTerm className="Row">visitId</DescriptionListTerm>
            <DescriptionListDescription className="content">
              {domainEvent.data['visitId']}
            </DescriptionListDescription>
          </DescriptionListGroup>
        </DescriptionList>
        {domainEvent.data['error'] ? (
          <DescriptionList
            columnModifier={{ xl: '1Col' }}
            className="additional-row"
          >
            <DescriptionListGroup key={descriptionListGroupKey(2)}>
              <DescriptionListTerm className="Row">Error</DescriptionListTerm>
              <DescriptionListDescription className="content">
                {domainEvent.data['error']}
              </DescriptionListDescription>
            </DescriptionListGroup>
          </DescriptionList>
        ) : null}
        <DescriptionList
          columnModifier={{ xl: '1Col' }}
          className="additional-row"
        >
          <DescriptionListGroup key={descriptionListGroupKey(3)}>
            <DescriptionListTerm className="Row">payload</DescriptionListTerm>
            <DescriptionListDescription className="content">
              <ExpandableSection
                toggleTextExpanded="Hide payload"
                toggleTextCollapsed="Show payload"
              >
                <CodeBlock>{domainEvent.data['payload']}</CodeBlock>
              </ExpandableSection>
            </DescriptionListDescription>
          </DescriptionListGroup>
        </DescriptionList>
      </Td>
    </Row>
  )
}
